import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { EXTERNAL_PATHS } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import ResourceSection from 'src/safety/components/ResourceSection';

const OwnerResources: FC = () => {
  const [t] = useTranslation('safety-page');

  return (
    <PitchPageLayout backgroundColor="pearl">
      <div>
        <ResourceSection
          title={t('resource--owner--title')}
          resourceListItems={[
            {
              iconId: 'bank',
              iconColor: 'sunset',
              title: t('resource--owner--item-0--title'),
              text: t('resource--owner--item-0--text'),
              linkText: t('resource--owner--item-0--linkText'),
              linkHref: `${EXTERNAL_PATHS.JOURNAL}boating-safety/boating-laws-and-regulations-by-states/`,
            },
            {
              iconId: 'category-lessons',
              iconColor: 'sand',
              title: t('resource--owner--item-2--title'),
              text: t('resource--owner--item-2--text'),
              linkText: t('resource--owner--item-2--linkText'),
              linkHref: `${EXTERNAL_PATHS.JOURNAL}boating-safety/boater-education-courses-and-certifications/`,
            },
          ]}
        />
      </div>
    </PitchPageLayout>
  );
};

export default OwnerResources;
